import React from 'react';
import cn from 'classnames';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { IFilling } from '@/finsight/domain/vo/Filings/Filings';
import { getDealRoute } from '@/finsight/Router/RouteWithRedirect/getNewRoute';
import Cell from './Cell';

import filingsCellsStyles from './filingsCells.scss';

const findEntityInData = (filing, cik) => {
  let filers = filing.data['SEC-HEADER'].FILER;
  filers = Array.isArray(filers) ? filers : [filers];
  const file = filers.find((file) => file['COMPANY-DATA'].CIK === cik);
  return file ? file['COMPANY-DATA']['CONFORMED-NAME'] : '';
};

const getCell = ({ row: filing }: { row: IFilling }) => {
  const cellProps = {
    tooltip: '',
    href: '',
    content: '',
  };
  cellProps.content = findEntityInData(filing, filing.filerCik);

  cellProps.href = !filing.deal
    ? ''
    : getDealRoute(filing.deal);

  cellProps.tooltip = cellProps.content;

  if (filing.deal) {
    cellProps.tooltip = `${ filing.deal.primaryIssuer.name }: ${ filing.deal.seriesName }`;
  }

  return (
    <Cell
      { ...cellProps }
      className={ cn(filingsCellsStyles.textOverflow, filingsCellsStyles.nameCell) }
    />
  );
};

interface INameCellPropTypes {
  rowIndex: number,
  filing: IFilling,
}

const LoanLevelNameCell = ({
  rowIndex,
  filing,
}: INameCellPropTypes) => (
  <BodyCell
    name="LoanLevelNameCell"
    dataTest="loanLevelNameCell"
    className={
      cn(
        filingsCellsStyles.unstyledLink,
        filingsCellsStyles.mainField,
        filingsCellsStyles.textOverflow,
        filingsCellsStyles.nameCell,
      )
    }
    rowIndex={ rowIndex }
    rowData={ filing }
    cellCallback={ getCell }
  />
);

export default LoanLevelNameCell;
